var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNavHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0001 8.02393L14.0001 2.76393C12.8613 1.74536 11.1389 1.74536 10.0001 2.76393L4.0001 8.02393C3.35754 8.5986 2.99324 9.42191 3.00009 10.2839V19.0239C3.00009 20.6808 4.34324 22.0239 6.00009 22.0239H18.0001C19.6569 22.0239 21.0001 20.6808 21.0001 19.0239V10.2739C21.0041 9.41539 20.64 8.59629 20.0001 8.02393ZM14.0001 20.0239H10.0001V15.0239C10.0001 14.4716 10.4478 14.0239 11.0001 14.0239H13.0001C13.5524 14.0239 14.0001 14.4716 14.0001 15.0239V20.0239ZM19.0001 19.0239C19.0001 19.5762 18.5524 20.0239 18.0001 20.0239H16.0001V15.0239C16.0001 13.3671 14.6569 12.0239 13.0001 12.0239H11.0001C9.34324 12.0239 8.00009 13.3671 8.00009 15.0239V20.0239H6.0001C5.44781 20.0239 5.0001 19.5762 5.0001 19.0239V10.2739C5.00046 9.9867 5.12431 9.7135 5.3401 9.52393L11.3401 4.27393C11.7176 3.94229 12.2826 3.94229 12.6601 4.27393L18.6601 9.52393C18.8759 9.7135 18.9997 9.9867 19.0001 10.2739V19.0239Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavHome);
export default ForwardRef;